import { getLastPagePvargsOfGIO, gioEvariableTrack } from './index';

const tqPvPaths = [
    '/new/tqcz/index.html',
    '/new/tqcz/pay/pay.html',
    '/new/tqcz/pay/detail.html',
    '/new/tqcz/finish/finish.html',
    '/new/tqcz/v2/index.html',
    '/new/tqcz/pay/v2/pay.html',
    '/new/tqcz/finish/v2/finish.html',
    '/new/#/ticketDetail',
    '/new/topic/views/kfc/restaurant.html',
    '/new/promo/chicken/entry.html',
    '/new/privilege_oil',
    '/new/topic/views/redirect/thirdParty.html',
    '/new/#/nearbyGoods',
    '/movie/union/front-index',
];

function handlePV() {
    const result = tqPvPaths.find(key => {
        return window.location.href.includes(key);
    });

    window.onbeforeunload = function() {
        window.localStorage.setItem('sourcePage', window.location.href);
    };

    window.onhashchange = function() {
        gioEvariableTrackOfPrivilege('pageView', {
            data: {
                pageName_var: document.title,
                pageAddress_var: window.location.href,
                sourcePage_var: window.localStorage.getItem('sourcePage'),
            },
        });
    };

    if (result) {
        gioEvariableTrackOfPrivilege('pageView', {
            data: {
                pageName_var: document.title,
                pageAddress_var: window.location.href,
                sourcePage_var: window.localStorage.getItem('sourcePage'),
            },
        });
    }
}

handlePV();

// # 特权的上报
export function gioEvariableTrackOfPrivilege(action, options = {}) {
    let data = options.data || {};
    const isNeedEntrance = options.isNeedEntrance || false;
    if (isNeedEntrance) {
        const lastPagePvargsOfGIO = getLastPagePvargsOfGIO();
        data = {
            ...lastPagePvargsOfGIO,
            ...data,
        };
    }

    // ? 发现空值统一转化'/'，只考虑shallow处理，因为不涉及多层嵌套的数据，有的话搞个函数自己递归
    data = Object.entries(data).reduce((o, [key, value]) => {
        // o[key] = (Object.prototype.toString.call(value) === '[object Number]' ? value : value) || '/';
        o[key] = value || '/';
        return o;
    }, {});

    gioEvariableTrack(action, {
        firstBusinessType_var: '特权',
        secBusinessType_var: getSecBusinessType(),
        thirdBusinessType_var: '/', // ? 有可能只是一个二级pv页，例如周边首页
        ...data,
    });
}

// # 匹配特权的二级业务
function getSecBusinessType() {
    const fullPath = location.pathname + location.hash;
    const prefix = '(#){0,1}(/new){0,1}';
    const map = {
        [`${prefix}/(.*nearbyGoods)`]: '周边',
        [`${prefix}/(.*ticket|.*coupon)`]: '卡券',
        [`${prefix}/(.*tqcz)`]: '充值',
        [`${prefix}/(.*elephant_oil|.*privilege_oil)`]: '加油',
        [`${prefix}/(.*topic/views/kfc|.*promo/chicken)`]: '炸鸡',
        [`${prefix}/(.*topic/views/superMarket)`]: '超市',
    };
    const target = Object.keys(map).find(key => new RegExp(key).test(fullPath));
    return map[target] || fullPath; // ? 既然不知道那就放出路径，方便下一次修改
}
